<template>
  <div class="faq" >
    <h2 class="faq-title-h2">Questions</h2>
    <h4 class="faq-title-h4">answers</h4>

    <div class="faq-item" >
      <q-expansion-item
        :expand-icon="matKeyboardDoubleArrowDown"
        :expanded-icon="matKeyboardDoubleArrowUp"

        label="I have an idea for <insert crazy idea>, can you do it?"
        class="faq-item-header"
        default-opened
      >
        <q-card>
          <q-card-section class="faq-item-text">
            Yes we can, let's talk! Please use the <q-btn class="bldr-submit-faq" outline rounded size="md" @click="scrollToForm" aria-label="Submit your idea">Form</q-btn> and we'll get back to you as soon as possible. 
          </q-card-section>
        </q-card>
      </q-expansion-item>
    </div>

    <div class="faq-item" >
      <q-expansion-item
        :expand-icon="matKeyboardDoubleArrowDown"
        :expanded-icon="matKeyboardDoubleArrowUp"

        label="What stack do you use?"
        class="faq-item-header"
        default-opened
      >
        <q-card>
          <q-card-section class="faq-item-text">
            The sensible answer would be.. it depends. We currently love Vue & Quasar and a backend of Express, Node, mySQL & nginx. But Wordpess might be better for SEO. Bootstrapped PHP would be better again and faster, but slower to implement. If a library doesn't exist we might need some glue, maybe Python or for deep pockets C.
          </q-card-section>
        </q-card>
      </q-expansion-item>
    </div>


    <div class="faq-item" >
      <q-expansion-item
        :expand-icon="matKeyboardDoubleArrowDown"
        :expanded-icon="matKeyboardDoubleArrowUp"

        label="What do you like?"
        class="faq-item-header"
        default-opened
      >
        <q-card>
          <q-card-section class="faq-item-text">
          Automation, we love to automate. Very large database driven sites. Image manipulation, data manipulation. Fast code. Optimized SQL. Components. Efficient domain names. Simple UI.
          </q-card-section>
        </q-card>
      </q-expansion-item>
    </div>


  </div>

  
</template>

<style scoped>

  .faq{
    text-align: center;
    margin: 0px auto;
    max-width: 1000px;   
  }

  .faq-title-h2 {
    letter-spacing: unset;
    padding:unset;
    margin-block-end: 0px;
    margin-block-start: 0px;
    font-weight: 500;
    line-height:1.2em !important;
    font-size: 4rem;  
    color: #474747;
    margin:0 20px 20px 20px;
  }
  .faq-title-h4{
    padding:unset;
    font-size: 2rem;
    margin:0 20px 48px 20px;
  }
  .faq-item{
    text-align: left;
    width:100%;
    border: 1px solid #ddd;
    background-color: #fff;
    border-radius: 32px;
    line-height: 1.4;
    transition: transform 0.20s ease;
    padding: 16px 16px 16px 16px;    
    margin-bottom:16px;
  }
  
  .faq-item:hover{
    box-shadow: 0 32px 40px -16px rgba(25, 25, 25, 0.1);  
    transform: translate(0, -4px);
    opacity: 1;
    border: 1px solid #aaa;    
  }

  .faq-item-header{
    font-weight: 600;
    font-size: 1.6rem;    
  }

  .faq-item-section-header{
    font-weight: 600;
    font-size: 1.6rem;    
  }

  .faq-item-text{
    font-weight: 400;
    font-size: 1.5rem;
  }

  .faq-acme-wrapper{
    display:block;
    margin: 16px auto 0 auto; 
  }
  .faq-acme-wrapper-img{
    max-width: 100%; 
    height: auto;   
    display: block; 
    margin: auto auto;
  }


  @media (max-width: 620px) { 
    .faq-title-h2 {
      font-size: 3rem; 
      padding:0 20px 0 20px;
      margin-bottom: 10px;
    }
    .faq-title-h4 {
      font-size: 1.5rem; 
      padding:0 20px 0 20px;
      margin-bottom: 48px;
    }

    .faq-item-header{
      font-size: 1.5rem;    
    }
    .faq-item-section-header{
      font-size: 1.5rem;    
    }
    .faq-item-text{
      font-size: 1.25rem;
    }

    .faq-item{
      padding: 12px 12px 12px 12px;
      border-radius: 16px;
    }

  }

  @media (max-width:500px){
    .faq-item-header{
      font-size: 1.25rem;    
    }
    .faq-item-section-header{
      font-size: 1.25rem;    
    }
    .faq-item-text{
      font-size: 1rem;
    }

    .faq-item{
      padding: 8px 8px 8px 8px;
      
    }

  }

  body.body--dark .faq-title-h2 {
    color: #eee; /* 158bff, 1976d2 */
  }
  body.body--dark .faq-title-h4 {
    color: #ddd; /* 158bff, 1976d2 */
  }
  body.body--dark .faq-title-h5 {
    color: rgb(68,68,68); /* 158bff, 1976d2 */
  }

  body.body--dark .faq-item{
    color:#fff;
    background-color: #999 !important;
  }
  body.body--dark .faq-item-text{
    background-color: #999 !important;
  }
  body.body--dark .faq-item-header{
    background-color: #999 !important;
  }
  

</style>

<script setup>

  //import { getVisState, toggleVis } from '../utils.js';
  import { matKeyboardDoubleArrowUp, matKeyboardDoubleArrowDown } from '@quasar/extras/material-icons';
  //import { ref } from 'vue';

  const scrollToForm = () => {
    const element = document.getElementById('submitForm');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  //const defaultvis = true;              //default for this card
  //const localkey = 'faqVis';
  //const localvis = ref(defaultvis); 

  //getVisState(localvis, localkey, defaultvis);

  //refs (eg localvis) when used in a template get automatically unwrapped, need to call toggleVis from within script setup to maintain reactivity
  //const updateVis = (localKey) => {
  //  toggleVis(localvis, localKey);
  //}


</script>